// Type-only on purpose: a value import here would add a module edge from utils
// into xstate (see build-selected-solution.ts).
import type {
  ProStudioContext,
  SelectedSolution,
} from '../xstate/prostudio.xstate.types';

type Solutions = ProStudioContext['solutions'];
type SolutionType = NonNullable<Solutions>[number]['type'];

/**
 * Folds a Main/Survey switch into the solutions list. Matched on the solution
 * uuid: `botSolutionId` is null on every v2 solution, so matching on it never
 * updated the list (PSTUDIO-4354).
 */
export const applySwitchedSolutionType = (
  solutions: Solutions,
  switched: SelectedSolution
): Solutions =>
  solutions?.map((bot) =>
    !!switched.uniqueId && bot.id === switched.uniqueId
      ? {
          ...switched,
          ...bot,
          versions: switched.versions,
          draftVersion: switched.draftVersion,
          botType: switched.botType,
          // The list entry carries the column from GetSolutions, and
          // `readBotType` prefers it; left stale, re-selecting this row
          // rebuilt the solution with the type it had before the switch.
          // The enum's values are exactly the BotType strings.
          type: switched.botType as SolutionType,
        }
      : bot
  );
